import { Layout } from 'antd';
import { BrowserRouter as Router,Redirect } from 'react-router-dom';
import HomePage from '../../containers/HomePage/HomePage';
import Profile from '../../containers/Profile/Profile';
import InstallationGuide from '../../containers/InstallationGuide/InstallationGuide';
import InstallationGuideBeacon from '../../containers/InstallationGuide/InstallationGuideBeacon';
import Routes from '../Routes/Routes';
import MyFooter from '../MyFooter/MyFooter';
import MainHeader from '../MainLayout/MainHeader';
import { useAuthContext } from '../../shared/context/auth-context';

export default function AuthencticatedApp() {
    const { Header, Content } = Layout;
    const { logout, rememberMe, deviceType } = useAuthContext()
console.log(deviceType);
console.log("deviceType");

    const routes = [
        {
            id: 1,
            path: '/profile',
            exact: true,
            component: <Profile />
          },
        //   {
        //     id: 2,
        //     path: '/obdguide',
        //     exact: true,
        //     component: <InstallationGuide />
        //   },
          {
            id: 2,
            path: '/guide',
            exact: true,
            component: deviceType==="mobile"?<InstallationGuideBeacon />:<InstallationGuide />
          },
          {
            id: 3,
            path: '/',
            exact: false,
            component: (
              <>
                <Redirect to="/" />
                <HomePage />
              </>
            )
          }
        ]

    const styles = {
        layout: {
            backgroundColor:'#F0F0F0'
        },
    }

    window.addEventListener("beforeunload", (ev) => {
        if (rememberMe === false) {
            const event = ev
            event.preventDefault();
            logout()
        }
    });

    return (
        <Router>
            <Layout style={{ minHeight: '100vh', ...styles.layout }}>
                <Header style={{ backgroundColor: '#fff', position: 'sticky', width: '100% ', top:0 ,zIndex:9999 }} >
                    <MainHeader  headerMenuRender='true' />
                </Header>
                <Layout style={styles.layout}>
                    <Content >
                        <Routes  routes= {routes}/>
                    </Content>
                </Layout>
                <MyFooter />
            </Layout>
        </Router>
    )
}